export default {"src":"/_next/static/media/twitter-x-black.213b1710.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};